export interface ProblemDescription {
  theme: string;
  description: string;
  attachments: File[];
}

export const EMPTY_DESCRIPTION: ProblemDescription = {
  theme: '',
  description: '',
  attachments: [],
};
